import React from "react";
import { Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Header from "../atoms/Header";
import PageTimer from "../../analytics/PageTimer";

const TermsCondition = () => {
  const navigate = useNavigate();
  
  return (
    <Stack sx={{ minHeight: "95vh", minWidth: "100vw" }}>
      <Header backAction={() => navigate("/confirm-order")} />
      <iframe
        src="https://business.growsari.com/terms-conditions/"
        style={{ marginTop: -35 }}
        title="Terms and Conditions"></iframe>
      <PageTimer />
    </Stack>
  );
};

export default TermsCondition;
